<template>
  <div class="audio u-pad-y-xl u-pad-y-md--sm u-row u-center">
    <div class="audio__card u-bg-white u-radius u-pad-md u-w6of12 u-w10of12--sm">
      <div @click.prevent="playSound" class="u-inline-block u-left u-marg-l-md u-w1of12">
        <img class="audio__icon" v-if="isPlaying" src="/images/pause__icon.png" alt="Pause icon"/>
        <img class="audio__icon" v-else src="/images/play__icon.png" alt="Play icon"/>
        <audio ref="audio__sound" :src="data.song[0].url"></audio>
      </div>
     
      <div class="u-inline-block u-w9of12 u-marg-l-1of12 u-blue-txt">
        <p class="u-marg-0 u-italic">{{duration}}</p>
        <p class="audio__title u-marg-0">{{data.titre}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
  },

  data() {
    return {
      isPlaying: false,
      duration: 0
    }
  },
  mounted () {
    this.player = this.$refs.audio__sound
    this.player.addEventListener('loadedmetadata', this.onAudioData)
  },

  methods: {
    onAudioData() {
      let sec= new Number()
      let min= new Number()

      sec = Math.floor( this.player.duration )    
      min = Math.floor( sec / 60 )
      min = min >= 10 ? min : '0' + min    
      sec = Math.floor( sec % 60 )
      sec = sec >= 10 ? sec : '0' + sec

      this.duration = min + ":"+ sec
    },
    playSound() {
      if (this.isPlaying) {
        this.player.pause()
        this.isPlaying = false
      } else {
        this.player.play()
        this.isPlaying = true
      }
    }
  }
}
</script>

<style lang="stylus">
.audio
    &__card
        box-shadow 3px 3px 5px 0px rgba(0 0 0 .1)
    &__icon
        width 35px
    &__title
        display -webkit-box
        -webkit-line-clamp 1
        -webkit-box-orient vertical
        overflow hidden

</style>